import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConstants } from '../../../../app-constants.service';
import { AuthService } from '../../../../services.module/auth.service';
import { ConfirmationObservable, MessageObservable } from '../../../../services.module/message.observable';
import { MeineDatenComponent } from '../meine-daten/meinedaten.component';
import { UserService } from '../../../../providers.module/user.service';
import { PartnerService } from '../../../../providers.module/partner.service';
import { ConfigurationApiService } from '../../../../../generated/api/configuration/configuration.service';
import { UserApiService } from '../../../../../generated/api/user/user.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'meinedaten-vm-for-kunde',
    templateUrl: '../meine-daten/meinedaten.component.html',
    styleUrls: ['../../../commonless/content.less', '../../../commonless/meine-daten.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MeineDatenVmForKundeComponent extends MeineDatenComponent implements OnDestroy {

    override modify: string;

    override iAmVermittler = true;
    override iAmSpy = true;

    private getPartnerSub: Subscription;

    constructor(
        protected override readonly authService: AuthService,
        protected override readonly route: ActivatedRoute,
        protected override readonly appConstants: AppConstants,
        protected override readonly confirmationHandler: ConfirmationObservable,
        protected override readonly messageHandler: MessageObservable,
        protected override readonly configurationApiService: ConfigurationApiService,
        protected override readonly userApiService: UserApiService,
        protected override readonly userService: UserService,
        protected readonly partnerService: PartnerService,
    ) {
        super(
            authService,
            route,
            appConstants,
            confirmationHandler,
            messageHandler,
            configurationApiService,
            userApiService,
            userService
        );

        this.getPartnerSub = this.partnerService.getPartner().subscribe(partnerResponse => {
            this.hisName = partnerResponse.nachnameOderName1.value;
        });
    }

    override ngOnDestroy() {
        super.ngOnDestroy();

        if (this.getPartnerSub) {
            this.getPartnerSub.unsubscribe();
        }
    }

}
